// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__xb64Q","ackoLogo":"navbar_ackoLogo__FaUt5"};